import { useTranslation } from 'react-i18next'

import { getOverrideMessage } from './../helpers'
import { textReason } from './../reasons'

const NoReturnableOrderContent = ({ reason = 'default', merchant, customTextReasons, disabledByRuleMessage }) => {
  const { i18n } = useTranslation()

  const getMessage = () => {
    const overrideMessage = getOverrideMessage({ reason, disabledByRuleMessage, lang: i18n.language })
    const specificReason = textReason(customTextReasons)[reason]?.(i18n.language, merchant)
    const defaultReason = textReason(customTextReasons).default(i18n.language, merchant)

    return overrideMessage || specificReason || defaultReason
  }

  return getMessage()
}

export default NoReturnableOrderContent
